// extracted by mini-css-extract-plugin
export var actionButton = "_dw-0";
export var attachmentLine = "_dw-1";
export var fileInput = "_dw-2";
export var fileUploadWrapper = "_dw-4";
export var footer = "_dw-3";
export var modalContent = "_dw-5";
export var paperclip = "_dw-6";
export var quillEditor = "_dw-7";